import React, { Component } from 'react'
import { Group, InfoDetails, Label, Tag, Title, Value } from '../styles/dialpadstyle';
import {
  Button
} from 'modules/theme';
export class CallInfoTheme extends Component {
  constructor(props) {
    super(props)
    this.startTimer = this.startTimer.bind(this);
    this.stopTimer = this.stopTimer.bind(this);
    this.previewTimer = props.previewTimer;
    this.previewStartTimer = props.previewStartTimer;
    this.timer = "";
    this.state = {
      time: props.previewTimer
    }
    this.startTimer();
  }
  stopTimer() {
    console.log(" stopTimer -----");
    clearInterval(this.timer)
  }
  startTimer() {
    const { doneFn } = this.props
    let _this = this;
    _this.stopTimer();
    console.log(" startTimer -----");
    this.timer = setInterval(() => {
      let current = parseInt(new Date() / 1000)
      let diff = current - _this.previewStartTimer
      console.log("Dial Number", diff, _this.previewTimer, _this.previewStartTimer, current, new Date());
      // console.log(" startTimer -----", diff > _this.previewTimer);
      if (diff < _this.previewTimer) {
        _this.setState({ time: (_this.previewTimer - diff) })
      } else {
        console.log(" startTimer Done-----", diff, diff > _this.previewTimer);
        doneFn();
        _this.stopTimer();
      }
    }, 1000)
  }
  renderList(info) {
    var list = [];
    if (info) {
      for (const key in info) {
        if (Object.hasOwnProperty.call(info, key)) {
          list.push(
            <Group>
              <Label>
                {key}
              </Label>
              <Value style={{ marginRight: '5px' }}>
                {info[key] || ""}
              </Value>
            </Group>
          );
        }
      }
    }
    return list;
  }
  render() {
    const { title, info, isPreview, doneFn, skipFn } = this.props;
    const { time } = this.state;
    return (
      <span style={{display: 'block', width: '100%'}}>
        <Title>
          {title}
        </Title>
        <InfoDetails>
          {this.renderList(info)}

        </InfoDetails>
        {isPreview && <Button
          btnStyle="filter"
          block
          onClick={() => {
            skipFn();
          }}
          size="medium"
          style={{ marginBottom: '10px', marginTop: '10px', fontWeight: '600' }}
        >
          {`Skip`}
        </Button>}

        {isPreview && <Button
          btnStyle="default"
          block
          onClick={() => {
            this.stopTimer()
            doneFn();
          }}
          size="medium"
          style={{ fontWeight: '600' }}
        >
          {`Dial ${time}`}
        </Button>}

      </span>
    )
  }
  componentWillUnmount() {
    this.stopTimer()
  }
}

export default CallInfoTheme


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/CallInfoTheme.js